/* eslint-disable react/require-default-props */
import React from 'react';

export default function PreviewChoiceIndicator({ type = 'radio', selected = false }) {
  return (
    <span
      className={[
        'cc-preview-choice-indicator',
        `cc-preview-choice-indicator--${type}`,
        selected ? 'cc-preview-choice-indicator--selected' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden
    />
  );
}
